var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"hide-footer":true,"centered":"","size":"xl","id":"update-modal","title":_vm.comunicado.title}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 my-4",staticStyle:{"overflow":"auto","display":"block","max-height":"600px"},domProps:{"innerHTML":_vm._s(_vm.comunicado.text)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }